/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobListSortCriteria {
    getFixupPrototypeFunction() { return PolicyJobListSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobListSortCriteria>): PolicyJobListSortCriteria {
        let obj = Object.assign(new PolicyJobListSortCriteria(), model);
        PolicyJobListSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobListSortCriteria>): PolicyJobListSortCriteria {
        if (!model) return null;
        return PolicyJobListSortCriteria.newInstance(<PolicyJobListSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobListSortCriteria) {
        if (!obj) return;

        models.PolicyJobListSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobListSortCriteria): boolean {
        Object.setPrototypeOf(obj, PolicyJobListSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.PolicyJobListSortColumn;

    ascending: boolean;

}
